// extracted by mini-css-extract-plugin
export var formContainer = "_hv-0";
export var message = "_hv-1";